import quoteService from '../services/quote.service';

/**
 * Open a quote's customer-facing PDF in a new tab — V1's 'View Quote' (pdf_quote.pl).
 *
 * The PDF arrives as a Blob rather than a URL (it is rendered on demand and the route is
 * authenticated), so it has to become an object URL before a tab can show it. Revoking
 * that URL immediately would race the new tab, which has not necessarily loaded it yet;
 * the delay below is what gives the tab time to take ownership. Not revoking at all
 * leaks the blob for the life of the document, which on a list page means one per click.
 *
 * Returns false instead of throwing: every caller renders its own message in its own
 * place, and a failed PDF should never take down the screen that offered it.
 *
 * `fetchPdf` is injectable for tests, matching the seam `QuoteLaneEditorDrawer` already
 * exposes as a prop.
 */
export async function openQuotePdf(
  quoteNumber: number,
  revisionNumber: number,
  fetchPdf: (q: number, r: number) => Promise<Blob> = quoteService.quotePdf,
): Promise<boolean> {
  try {
    const blob = await fetchPdf(quoteNumber, revisionNumber);
    const url = URL.createObjectURL(blob);
    window.open(url, '_blank', 'noopener');
    setTimeout(() => URL.revokeObjectURL(url), 60_000);
    return true;
  } catch {
    return false;
  }
}
